/**
 * @功能名称:
 * @文件名称: routes.js
 * @Date: 2018/5/21 下午4:54.
 * @Author: zhangdanqing
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
const login = () => import('./login.vue')
const register = () => import('./payRegister.vue')
const findPassStep1 = () => import('./findPassStep1.vue')
const findPassStep2 = () => import('./findPassStep2.vue')
const findPassStep3 = () => import('./findPassStep3.vue')
const findPassStep4 = () => import('./findPassStep4.vue')
const registerStep1 = () => import('./registerStep1.vue')
const registerStep2 = () => import('./registerStep2.vue')
const registerNew = () => import('./registerNew.vue')
const iframe = () => import('bjxy-component/iframe');
const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {level: 'b1', title: '登录'},
    component: login,
    props: (route) => ({query: route.query})
  },
  {
    path: '/register',
    name: 'register',
    meta: {level: 'b2', title: '注册'},
    component: register,
    props: (route) => ({query: route.query})
  },
  {
    path: '/findPassStep1',
    name: 'findPassStep1',
    meta: {level: 'b3', title: '找回密码'},
    component: findPassStep1,
    props: (route) => ({query: route.query})
  },
  {
    path: '/findPassStep2',
    name: 'findPassStep2',
    meta: {level: 'b4', title: '找回密码'},
    component: findPassStep2,
    props: (route) => ({query: route.query})
  },
  {
    path: '/findPassStep3',
    name: 'findPassStep3',
    meta: {level: 'b5', title: '找回密码'},
    component: findPassStep3,
    props: (route) => ({query: route.query})
  },
  {
    path: '/findPassStep4',
    name: 'findPassStep4',
    meta: {level: 'b6', title: '找回密码'},
    component: findPassStep4,
    props: (route) => ({query: route.query})
  },
  {
    path: '/registerStep1',
    name: 'registerStep1',
    meta: {level: 'b2', title: '手机号快速注册'},
    component: registerStep1,
    props: (route) => ({query: route.query})
  },
  {
    path: '/registerStep2',
    name: 'registerStep2',
    meta: {level: 'b3', title: '手机号快速注册'},
    component: registerStep2,
    props: (route) => ({query: route.query})
  },
  {
    path: '/registerNew',
    name: 'registerNew',
    meta: {level: 'b3', title: '注册'},
    component: registerNew,
    props: (route) => ({query: route.query})
  },
  {
    path: '/iframe',
    name: 'iframe',
    meta: {level: 'c1', title: ''},
    component: iframe,
    props: (route) => ({query: route.query}),
  },
];
export default routes;
